import clsx from 'clsx'
import React from 'react'

type Props = {
    id: string
    label: React.ReactNode
    checked: boolean
    onChange: (checked: boolean) => void
    disabled?: boolean
    description?: React.ReactNode
    name?: string
    className?: string
}

function CheckboxInput({
    id,
    label,
    checked,
    onChange,
    disabled = false,
    description,
    name,
    className,
}: Props): React.JSX.Element {
    return (
        <label
            htmlFor={id}
            className={clsx(
                'flex items-start gap-3 text-sm',
                disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
                className,
            )}
        >
            <input
                id={id}
                name={name}
                type="checkbox"
                checked={checked}
                onChange={(event) => onChange(event.target.checked)}
                disabled={disabled}
                className="mt-1 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            <div className="flex flex-col gap-1 text-gray-800">
                <span className="font-medium text-gray-900">{label}</span>
                {description && (
                    <span className="text-xs leading-5 text-gray-600">
                        {description}
                    </span>
                )}
            </div>
        </label>
    )
}

export default CheckboxInput
